/**
 * Helper util to replace all href/src URLs with
 * agnostic protocols to support both HTTP/HTTPS
 */
var agnostify = function agnostify(text) {
  return text.replace(/(?!'|")http(s?):\/\//gi, '//');
};

export default agnostify;